//react packages
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import React, { Suspense } from 'react';

//Main layout
// import WFMHome from './layout/MainLayout/MainLayout';
// Sidebar navigation
// import Dashboard from './newsintelligence/dashboard/Dashboard';
// import Billing from './newsintelligence/billing/Billing';
// import Overview from './newsintelligence/WFMHome';
// import Calendar from './newsintelligence/calendar/Calendar';
// import Contact from './newsintelligence/contact/Contact';
// import CreateSR from './newsintelligence/servicerequest/CreateSR';
// import Usersbase from './newsintelligence/users/Users';
// import Reporting from './newsintelligence/reporting/Reporting';
// Settings
// import Settings from './newsintelligence/settings/settings';

// import Support from './newsintelligence/support/Support';
// import AllNotifications from './newsintelligence/notifications/AllNotifications';
// Signin
import Signin from './LandingPage/signin';
import Home from './LandingPage/home';
import VerifyEmail from './LandingPage/verify-email';
import ResetPassword from './LandingPage/reset-password';
import NotFound from './LandingPage/NotFound';
import DocumentationPage from './legal/pages/DocumentationPage';
import ProductsPage from './LandingPage/products/ProductsPage';
import ProductsProfilePage from './LandingPage/products/ProductsProfilePage';
import AudioPlayerProductPage from './layout/ReusableComponent/audioPlayer/AudioPlayerProductPage';
import TextEditorProductPage from './layout/ReusableComponent/Text-editor/TextEditorProductPage';
import PrivacyPage from './legal/pages/PrivacyPage';
import TermsPage from './legal/pages/TermsPage';
import ContactPage from './legal/pages/ContactPage';
import CodeOfConductPage from './legal/pages/CodeOfConductPage';
import AcceptableUsePage from './legal/pages/AcceptableUsePage';
import FairUsePage from './legal/pages/FairUsePage';
import SafetyReportPage from './legal/pages/SafetyReportPage';
import RegionalCompliancePage from './legal/pages/RegionalCompliancePage';
import OpenSourcePage from './legal/pages/OpenSourcePage';
import ProtectedRoute from './LandingPage/ProtectedRoute';
import { SessionAuthProvider } from './utils/SessionAuthContext';
import { GlobalStorageBoxAudioProvider } from './layout/ReusableComponent/audioPlayer/globalStorageBoxAudioSession';
import GlobalStorageBoxAudioHost from './layout/ReusableComponent/audioPlayer/GlobalStorageBoxAudioHost';
import PostsGuestRoute from './LandingPage/PostsGuestRoute';
import CashflowGuestRoute from './costingApps/Cashflow/CashflowGuestRoute';
import StorageBoxApp from './storageBox/StorageBoxApp';
import StorageBoxAuthGate from './storageBox/StorageBoxAuthGate';
import SessionRenewal from './hooks/SessionRenewal';
import NotificationsPage from './newsintelligence/notifications/NotificationsPageShell';
import MessagingPageShell from './newsintelligence/MainHeader/Messaging/MessagingPageShell';
import MessagesApp from './messages/MessagesApp';
import MessagingPageSkeleton from './newsintelligence/MainHeader/Messaging/MessagingPageSkeleton';
import { CashflowListPageSkeleton } from './costingApps/Cashflow/components/CashflowPageSkeleton';
import {
  AdminPanelRouteSkeleton,
  NotificationsTimelineSkeleton,
  PostsFeedPageRouteSkeleton,
} from './layout/ReusableComponent/Skeleton/RouteSkeletons';
import './layout/ReusableComponent/Skeleton/RouteSkeletons.css';

// css
// import './assets/fonts/fonts.css';

import './App.css';

const PostsPage = React.lazy(() => import('./GlobalPosts/PostsPage'));
const AdminPanelPage = React.lazy(() => import('./GlobalPosts/adminpanel/AdminPanelPage'));
const CashflowApp = React.lazy(() => import('./costingApps/Cashflow/CashflowApp'));
const StorageBoxSharePage = React.lazy(() => import('./storageBox/pages/StorageBoxSharePage'));
const SearchPageShell = React.lazy(() => import('./newsintelligence/search/SearchPageShell'));

const Layout = () => {
  return (
    // <>
      <Router>
          <SessionAuthProvider>
          <GlobalStorageBoxAudioProvider>
          <SessionRenewal />
          <Routes>
            {/*  Unprotected / Public */}
            <Route path="/home" element={<Home />} />
            <Route path="/" element={<Navigate to="/products" replace />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/audio-player" element={<AudioPlayerProductPage />} />
            <Route path="/text-editor" element={<TextEditorProductPage />} />
            <Route path="/docs" element={<DocumentationPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/legal/code-of-conduct" element={<CodeOfConductPage />} />
            <Route path="/legal/acceptable-use" element={<AcceptableUsePage />} />
            <Route path="/legal/fair-use" element={<FairUsePage />} />
            <Route path="/legal/safety" element={<SafetyReportPage />} />
            <Route path="/legal/regional" element={<RegionalCompliancePage />} />
            <Route path="/legal/open-source" element={<OpenSourcePage />} />
            <Route path="/sm/terms" element={<Navigate to="/terms" replace />} />
            <Route
              path="/notifications"
              element={
                <Suspense fallback={<NotificationsTimelineSkeleton />}>
                  <ProtectedRoute>
                    <NotificationsPage />
                  </ProtectedRoute>
                </Suspense>
              }
            />
            <Route
              path="/sm/all-messages"
              element={
                <Suspense fallback={<MessagingPageSkeleton />}>
                  <ProtectedRoute>
                    <MessagingPageShell />
                  </ProtectedRoute>
                </Suspense>
              }
            />
            <Route
              path="/messages"
              element={
                <Suspense fallback={<MessagingPageSkeleton />}>
                  <ProtectedRoute>
                    <MessagesApp />
                  </ProtectedRoute>
                </Suspense>
              }
            />
            {/* <Route path='/d/createSR' Component={CreateSR} /> */}
            
            {/* Global Posts */}
            <Route
              path="/search"
              element={
                <Suspense fallback={<PostsFeedPageRouteSkeleton />}>
                  <PostsGuestRoute>
                    <SearchPageShell />
                  </PostsGuestRoute>
                </Suspense>
              }
            />
            <Route
              path="/posts/:contentType/:slug"
              element={
                <Suspense fallback={<PostsFeedPageRouteSkeleton />}>
                  <PostsGuestRoute>
                    <PostsPage />
                  </PostsGuestRoute>
                </Suspense>
              }
            />
            <Route
              path="/posts/p/:slug"
              element={
                <Suspense fallback={<PostsFeedPageRouteSkeleton />}>
                  <PostsGuestRoute>
                    <PostsPage />
                  </PostsGuestRoute>
                </Suspense>
              }
            />
            <Route
              path="/posts"
              element={
                <Suspense fallback={<PostsFeedPageRouteSkeleton />}>
                  <PostsGuestRoute>
                    <PostsPage />
                  </PostsGuestRoute>
                </Suspense>
              }
            />
            <Route
              path="/posts/gvalley"
              element={
                <Suspense fallback={<AdminPanelRouteSkeleton />}>
                  <PostsGuestRoute>
                    <AdminPanelPage />
                  </PostsGuestRoute>
                </Suspense>
              }
            />

            {/* Protected / Authenticated */}
            <Route
              path="/costing/cashflow/*"
              element={
                <Suspense fallback={<CashflowListPageSkeleton />}>
                  <CashflowGuestRoute>
                    <CashflowApp />
                  </CashflowGuestRoute>
                </Suspense>
              }
            />
            <Route
              path="/storagebox/share/:token"
              element={
                <Suspense fallback={<CashflowListPageSkeleton />}>
                  <StorageBoxSharePage />
                </Suspense>
              }
            />
            <Route
              path="/storagebox"
              element={
                <StorageBoxAuthGate>
                  <StorageBoxApp />
                </StorageBoxAuthGate>
              }
            />
            <Route
              path="/storagebox/*"
              element={
                <StorageBoxAuthGate>
                  <StorageBoxApp />
                </StorageBoxAuthGate>
              }
            />
            <Route
              path="/d/profile"
              element={
                <ProtectedRoute>
                  <ProductsProfilePage />
                </ProtectedRoute>
              }
            />

            {/* Catch-all route for undefined routes */}
            <Route path="*" element={<NotFound />} />
              
          </Routes>
          <GlobalStorageBoxAudioHost />
          </GlobalStorageBoxAudioProvider>
          </SessionAuthProvider>
      </Router>
    // </>
  );
}

export default Layout;